import Slider from 'react-slick';
import TitleSection from 'components/common/TitleSection';
import { clientReviewData } from 'helpers/homeHelper';

const ClientsReviewCarousel = () => {
  const titleDetail = {
    upperTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
    middleTitle: 'WHAT’S THE CLIENTS SAY',
    lowerTitle: '',
  };
  let settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
  };
  return (
    <section className='clientReviewCarousel DBlock py-10 sm:py-12 px-6 sm:px-10 bg-eventLightPink'>
      <div className='max-w-7xl mx-auto'>
        <TitleSection titleDetail={titleDetail} />
        <div className='DBlock'>
          <div className='grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-12 outline-none border-none'>
            <Slider {...settings} className='md:col-span-2 relative'>
              {clientReviewData?.map((list) => (
                <div key={`reviewCard${list?.id}`}>
                  <div className='grid grid-cols-1 md:grid-cols-2 gap-4 pb-2 px-4 place-items-center '>
                    <img src={list?.image} alt='clientImg' />
                    <div>
                      <h2 className='text-lg font-semibold'>{list?.name}</h2>
                      <p className='text-xs sm:text-sm text-eventGray py-4'>
                        {list?.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
            <div className='place-items-center hidden md:flex'>
              <img
                src='/assets/images/home/carousel/groupClientImg.png'
                alt='clientGroup'
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsReviewCarousel;
